import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { email_verification } from "../../api/auth";
import { useNavigate } from "react-router-dom";
import ConfirmationPage from "src/components/StatusBackground/ConfirmationPage";

const EmailConfirmation = () => {
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const [isProcessingConfirmation, setIsProcessingConfirmation] = useState(true);
  const [confirmEmail, setConfirmEmail] = useState(false);
  const [message, setMessage] = useState(null);

  // Extract 'gid' from URL query parameter
  const urlParams = new URLSearchParams(window.location.search);
  const gid = urlParams.get("gid");

  useEffect(() => {
    if (!gid) {
      setMessage(t("emailConfirmation.noGidfound"));
      setIsProcessingConfirmation(false);
      return;
    }

    // Real API call
    if (gid) {
      // Function to process email verification asynchronously
      async function verifyEmail(gid) {
        try {
          const response = await email_verification(gid);
          if (response.success) {
            setConfirmEmail(true);
            setMessage(response.message);
          } else {
            setMessage(response.message);
          }
        } catch (error) {
          console.error("An error occurred during email confirmation:", error);
        } finally {
          setIsProcessingConfirmation(false);
        }
      }
      verifyEmail(gid);
    }
  }, [gid, i18n.language, t]);

  return (
    <ConfirmationPage
      loading={isProcessingConfirmation}
      loadingMessage={t("emailConfirmation.processing")}
      error={!confirmEmail && !isProcessingConfirmation}
      title={confirmEmail ? t("emailConfirmation.successTitle") : t("emailConfirmation.errorTitle")}
    >
      {confirmEmail ? (
        <>
          <h4>{t("emailConfirmation.welcomeText")}</h4>
          <h4 className="email-response-message">{message}</h4>
          <p>{t("emailConfirmation.thankYouMessage")}</p>
        </>
      ) : (
        <>
          <h4 className="email-response-message">{message}</h4>
          <p>{t("emailConfirmation.retryMessage")}</p>
        </>
      )}
    </ConfirmationPage>
  );
};

export default EmailConfirmation;
